module.exports = __webpack_public_path__ + "img/login_background.85527a78.jpg";